import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { PointRecord } from "../../helper/PointRecord";

export const TimelineViewOptionsRecord = Record({
  layout: null,
  unitScale: null,
  scrollPosition: PointRecord(),
  splitByNarrative: false,
  groupIds: List() // Note: will contain itemIds and/or `Unallocated-typeId`...
});

const data = {
  objects: {
    scrollPosition: "PointRecord",
    groupIds: "List"
  }
};
createFromJS.registerCallback(
  "TimelineViewOptionsRecord",
  createFromJS.createNestedCallback(TimelineViewOptionsRecord, data)
);
